var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMycart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1875 16.875C12.9124 16.875 13.5 16.2874 13.5 15.5625C13.5 14.8376 12.9124 14.25 12.1875 14.25C11.4626 14.25 10.875 14.8376 10.875 15.5625C10.875 16.2874 11.4626 16.875 12.1875 16.875Z",
    fill: "#81878E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1875 16.875C6.91237 16.875 7.5 16.2874 7.5 15.5625C7.5 14.8376 6.91237 14.25 6.1875 14.25C5.46263 14.25 4.875 14.8376 4.875 15.5625C4.875 16.2874 5.46263 16.875 6.1875 16.875Z",
    fill: "#81878E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.63 2.955L3.48 4.7925C3.45 5.145 3.7275 5.4375 4.08 5.4375H15.5625C15.8775 5.4375 16.14 5.1975 16.1625 4.8825C16.26 3.555 15.2475 2.475 13.92 2.475H4.7025C4.6275 2.145 4.4775 1.83 4.245 1.5675C3.87 1.17 3.345 0.9375 2.805 0.9375H1.5C1.1925 0.9375 0.9375 1.1925 0.9375 1.5C0.9375 1.8075 1.1925 2.0625 1.5 2.0625H2.805C3.0375 2.0625 3.255 2.16 3.4125 2.325C3.57 2.4975 3.645 2.7225 3.63 2.955Z",
    fill: "#81878E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3825 6.5625H3.87754C3.56254 6.5625 3.30754 6.8025 3.27754 7.11L3.00754 10.3725C2.90254 11.655 3.90754 12.75 5.19004 12.75H13.53C14.655 12.75 15.645 11.8275 15.7275 10.7025L15.975 7.2C16.005 6.855 15.735 6.5625 15.3825 6.5625Z",
    fill: "#81878E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMycart);
export default __webpack_public_path__ + "static/media/mycart.4e0e13ba.svg";
export { ForwardRef as ReactComponent };